<template>
  <div>
    <div class="mb-12 to-hide">
      <v-layout justify-space-between align-center>
        <v-flex v-if="$route.query.preview" xs6>
          <div class="txt-head black--text">
            โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์
            (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)
          </div>
        </v-flex>
        <v-flex xs6>
          <v-layout justify-end mb-4>
            <v-flex shrink mr-4> </v-flex>
            <v-flex shrink mr-4>
              <v-btn
                color="#e51610"
                outlined
                rounded
                depressed
                @click.native="print()"
                v-if="$route.query.preview"
              >
                <Iconify
                  style="color: #e51610"
                  icon="fluent:document-pdf-24-filled"
                ></Iconify>
                <span style="color: #e51610">Export PDF </span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <divcard
        v-if="$route.query.preview"
        class="d-flex justify-space-between mb-2"
        style="gap: 24px"
      >
        <div class="d-flex" style="gap: 24px">
          <div>
            <v-img
              :src="require('@/assets/mhesr.png')"
              min-width="100"
              max-width="100"
              aspect-ratio="1"
            ></v-img>
          </div>

          <div class="page-title">สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.)</div>
        </div>

        <div class="budget-tag">
          <div>ปี งปม.</div>
          <div>
            {{ form?.area_form?.year }}
          </div>
        </div>
      </divcard>
    </div>
    <div class="d-flex flex-column gap-12 mb-6" id="pdf">
      <div
        class="d-flex flex-column align-center to-show"
        style="gap: 14px; display: none; visibility: hidden; height: 0px"
      >
        <div class="d-flex align-center">
          <v-img
            :src="require('@/assets/Logo2.png')"
            width="146"
            height="48"
            aspect-ratio="1"
          ></v-img>
        </div>

        <div class="d-flex align-center">
          <div class="page-title">แบบฟอร์ม Spider Chart</div>
        </div>
        <div class="d-flex align-center">
          <div class="txt-head">
            โดยอุทยานวิทยาศาสตร์ {{ user.region ?? "" }}
          </div>
        </div>
      </div>
      <divcard titled>
        <div
          class="txt-head black--text mb-2 d-flex align-items-center card-part-orange"
        >
          <span class="theme-color-one">ส่วนที่ 1 : </span>
          ข้อมูลบริษัท/หน่วยงาน
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one_one')"
            ></ValidatorIcon
            >1. ข้อมูลบริษัท/หน่วยงาน
          </div>
          <div class="mx-10 card-part mb-5">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6"> ชื่อบริษัท (ภาษาไทย) </v-col
                ><v-col class="py-0" cols="6">
                  {{ form.spider_chart_1?.company_name_th }}
                </v-col></v-col
              >
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6"> ชื่อบริษัท (ภาษาอังกฤษ) </v-col
                ><v-col class="py-0" cols="6">{{
                  form.spider_chart_1?.company_name_en
                }}</v-col></v-col
              >
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6">
                  ที่อยู่สำนักงานใหญ่ (Head Office Address) </v-col
                ><v-col class="py-0" cols="6">
                  {{ form.spider_chart_1?.company_address }}
                </v-col></v-col
              >
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6"> รหัสไปรษณีย์ (Postal) </v-col
                ><v-col class="py-0" cols="6">
                  {{ form.spider_chart_1?.company_postal_code }}
                </v-col></v-col
              >
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6"> โทรศัพท์ (Telephone No.) </v-col
                ><v-col class="py-0" cols="6">{{
                  form.spider_chart_1?.company_phone
                }}</v-col></v-col
              >
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6"> โทรสาร (Facsimile No.) </v-col
                ><v-col class="py-0" cols="6">
                  {{ form.spider_chart_1?.company_fac }}
                </v-col></v-col
              >
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6"> อีเมล (E-mail) </v-col
                ><v-col class="py-0" cols="6">{{
                  form.spider_chart_1?.company_email
                }}</v-col></v-col
              >
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6"> เว็บไซต์ (Website) </v-col
                ><v-col class="py-0" cols="6">
                  {{ form.spider_chart_1?.company_website }}
                </v-col></v-col
              >
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text pt-6 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one_two')"
            ></ValidatorIcon>
            2. อัพโหลดภาพบริษัท (Company Picture)
          </div>
          <div class="mx-10">
            <v-layout
              align-center
              class="mt-3"
              v-for="(file, f) in form.spider_chart_1?.attachments"
              :key="f"
            >
              <v-flex shrink class="to-hide">
                <v-btn
                  depressed
                  dark
                  rounded
                  width="125"
                  color="#F15A29"
                  @click="downloadFile(file)"
                >
                  <Iconify
                    style="color: #fff"
                    icon="system-uicons:download"
                  ></Iconify>
                  <span class="font-12 font-w-700">ดาวน์โหลด</span>
                </v-btn>
              </v-flex>
              <v-flex shrink ml-3>
                {{ file.file_name }}
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text pt-6 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one_three')"
            ></ValidatorIcon>
            3. คะแนนประเมิน (Evaluation score)
          </div>
          <div class="mx-10">
            คะแนนประเมิน
            <div class="mx-10">{{ percent ? percent + " %" : "" }}</div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one_four')"
            ></ValidatorIcon>
            4. ความต้องการใช้พื้นที่ (Space requirements)
          </div>
          <div>
            <div class="mx-10 card-part mb-4">
              <v-row class="pt-2">
                <v-col class="py-0 d-flex" cols="6"
                  ><v-col class="py-0" cols="6">
                    พื้นที่ ที่ต้องการใช้งาน </v-col
                  ><v-col class="py-0" cols="6">
                    {{ form.spider_chart_1?.space_needed }}
                  </v-col></v-col
                >
              </v-row>
              <v-row class="pt-2">
                <v-col class="py-0 d-flex" cols="6"
                  ><v-col class="py-0" cols="6"> ชั้น </v-col
                  ><v-col class="py-0" cols="6">
                    {{ form.spider_chart_1?.space_floor }}
                  </v-col></v-col
                >
                <v-col class="py-0 d-flex" cols="6"
                  ><v-col class="py-0" cols="6"> ห้อง </v-col
                  ><v-col class="py-0" cols="6">{{
                    form.spider_chart_1?.space_room
                  }}</v-col></v-col
                >
              </v-row>
              <v-row class="pt-2">
                <v-col class="py-0 d-flex" cols="6"
                  ><v-col class="py-0" cols="6"> ขนาดพื้นที่ </v-col
                  ><v-col class="py-0" cols="6">
                    {{ form.spider_chart_1?.space_area_size }}
                  </v-col></v-col
                >
              </v-row>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text pt-6 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one_five')"
            ></ValidatorIcon>
            5. รูปแบบการจัดตั้ง (Form of establishment)
          </div>
          <div class="mx-10">
            รูปแบบการจัดตั้ง (Form of establishment)
            <div class="mx-10">
              {{ form.spider_chart_1?.space_type }}
              {{ (form.spider_chart_1?.space_type == "อื่นๆ (ระบุ)" ) ? "(" + form.spider_chart_1?.space_type_other + ")" : "" }}
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text pt-6 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one_six')"
            ></ValidatorIcon>
            6. จำนวนบุคลากร (Number of personnel)
          </div>
          <div class="mx-10">
            จำนวนบุคลากร (Number of personnel)
            <div class="mx-10">
              {{ form.spider_chart_1?.number_of_person }}
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text pt-6 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one_seven')"
            ></ValidatorIcon>
            7. ประเภทผู้ใช้บริการพื้นที่ (Type of service user)
          </div>
          <div class="mx-10">
            <div class="">ประเภทผู้ใช้บริการพื้นที่</div>
            <div class="mx-10 mt-1">
              {{ form?.area_form?.area_form_2?.area_type?.name }}
            </div>
            <divcard class="mt-2">
              <img
                v-if="selectedRoomData"
                :src="`${apiDomain}assets/images/rooms/${selectedRoomData?.region}/${getPrefixImageByRegion(selectedRoomData?.region)}_${selectedRoomData?.name}.jpg`"
                class="img-fluid"
                alt="Sample Image"
                @error="handleImageError"
              />
              <div v-else class="no-image">No Image</div>
            </divcard>
          </div>
        </div>
      </divcard>
      <divcard titled>
        <div
          class="txt-head black--text mb-2 d-flex align-items-center card-part-orange"
        >
          <span class="theme-color-one">ส่วนที่ 2 : </span>
          รายละเอียด
        </div>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('two_one')"
            ></ValidatorIcon>
            1. ผลิตภัณฑ์ (Product)
          </div>
          <div class="mx-10">
            <v-row class="pt-2">
              <v-col class="py-0 text-center" cols="4"> ผลิตภัณฑ์ </v-col
              ><v-col class="py-0 text-center" cols="8"> รูปผลิตภัณฑ์ </v-col>
            </v-row>
            <v-row
              v-for="(i, index) in form?.spider_chart_2?.spider_chart_2_1"
              :key="index"
              class="pt-2 text-break"
            >
              <v-col class="py-0 text-center align-self-center" cols="4"> {{ i?.product_name }} </v-col
              ><v-col class="py-0 text-center" cols="8">
                <div>
                  <img
                    style="width: 150px; height: auto; object-fit: cover"
                    :src="i?.attachment?.url"
                  />
                </div>
                <div>
                  {{ i?.attachment?.file_name }}
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('two_two')"
            ></ValidatorIcon>
            2. กิจกรรมที่จะเกิดขึ้นภายในอาคาร
          </div>
          <div class="mx-10 text-break">
            {{ form.spider_chart_2?.activity }}
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('two_three')"
            ></ValidatorIcon>
            3. กิจกรรมสนับสนุนสำหรับอุทยานวิทยาศาสตร์
          </div>
          <div class="mx-10">
            <div>
              <v-row class="pt-2">
                <v-col class="py-0" cols="6"> ประเภทการบริการ </v-col
                ><v-col class="py-0" cols="6"> อัตราค่าบริการ </v-col>
              </v-row>
              <v-row
                v-for="(i, index) in form.spider_chart_2?.spider_chart_2_3"
                :key="index"
                class="pt-2"
              >
                <v-col class="py-0" cols="6"> {{ i?.service_type }} </v-col
                ><v-col class="py-0" cols="6">
                  {{
                    Number(i?.service_price || 0).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + " บาท"
                  }}
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('two_four')"
            ></ValidatorIcon>
            4. เสถียรภาพทางการเงิน (Financial stability)
          </div>
          <div class="mx-10">
            เสถียรภาพทางการเงิน
            <div class="mx-10 text-break">
              {{ form?.spider_chart_2?.financial_stability }}
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex gap-8">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('two_five')"
            ></ValidatorIcon>
            5. ความร่วมมือที่ผ่านมา (Past cooperation)
          </div>
          <div class="mx-10">
            ความร่วมมือที่ผ่านมา
            <div class="mx-10 text-break">
              {{ form?.spider_chart_2?.past_cooperation }}
            </div>
          </div>
        </div>
      </divcard>
      <divcard titled>
        <div
          class="txt-head black--text mb-2 d-flex align-items-center card-part-orange"
        >
          <span class="theme-color-one">ส่วนที่ 3 : </span>
          กิจกรรม
        </div>
        <div>
          <div class="d-flex justify-space-between card-part pt-6 mx-5">
            <div
              v-for="(item, i) in tableHeader"
              :key="i"
              :style="{ width: item.width }"
              class="txt-bigger"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="card-part mx-5">
            <div
              v-if="form.spider_chart_3 && form.spider_chart_3.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in form.spider_chart_3"
                :key="i"
                class="d-flex mb-3"
              >
                <div
                  class="flex text-break"
                  style="min-width: 10%; max-width: 10%"
                >
                  {{ item.year }}
                </div>
                <div
                  class="flex text-break"
                  style="min-width: 20%; max-width: 20%"
                >
                  {{ item.name }}
                </div>
                <div
                  class="flex text-break"
                  style="min-width: 30%; max-width: 30%"
                >
                  {{ item.plan }}
                </div>
                <div
                  class="flex text-break"
                  style="min-width: 15%; max-width: 15%"
                >
                  {{
                    Number(item.budget || 0).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + " บาท"
                  }}
                </div>
                <div class="flex" style="min-width: 15%; max-width: 15%">
                  <!-- {{ toDateFormat2(item.duration_from) }} ถึง
                  {{ toDateFormat2(item.duration_to) }} -->
                   {{ item.duration }}
                </div>
                <div
                  class="flex text-break"
                  style="min-width: 10%; max-width: 10%"
                >
                  {{
                    item?.source_topical.join(", ") +
                    (item?.source_topical_other
                      ? "(" + item?.source_topical_other + ")"
                      : "")
                  }}
                </div>
              </div>
            </div>
            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </divcard>
    </div>
    <div
      v-if="$route.query.preview"
      class="d-flex justify-space-between to-hide"
    >
      <Button theme="2" @onClick="$router.push({ name: 'spaceRequestsOffer' })"
        >ยกเลิก</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Button from "../../components/input/Button";
import ValidatorIcon from "../../components/ValidatorIcon";
import Divcard from "../../components/Divcard.vue";
import { toDateFormat2, formatNumber } from "@/plugins/global-funcs";
import { mapState } from "vuex";
import { apiDomain } from "@/store/constants";


export default {
  components: { Divcard, ValidatorIcon, Button },
  data() {
    return {
      apiDomain,
      toDateFormat2,
      formatNumber,
      form: {},
      masterData: {},
      selectedRoomData: null,
      percent: null,
      tableHeader: [
        {
          name: "ปีที่",
          width: "10%",
        },
        {
          name: "ชื่อโครงการ",
          width: "20%",
        },
        {
          name: "แผนการดำเนินงาน",
          width: "30%",
        },
        {
          name: "งบประมาณ",
          width: "15%",
        },
        {
          name: "ระยะเวลา ดำเนินการ",
          width: "15%",
        },
        {
          name: "แหล่งทุน",
          width: "10%",
        },
      ],
    };
  },
  created() {
    this.retrieveForms();
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.Auth.User,
      user: (state) => state.Auth.User,
    }),
  },
  methods: {
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit("General/setModal", {
            title: "ระบบไม่พบไฟล์ที่ร้องขอ",
            theme: "warning",
            text: "กรุณาติดต่อเจ้าหน้าที่",
            showCancel: false,
            buttonText: "ตกลง",
          });
        });
    },
    retrieveForms() {
      // Retrieve the form data
      this.$apiFire("Request/getSpiderChartById", {
        id: this.$route.params.id,
      }).then((res) => {
        console.info("getSpiderChartById: ", res);
        if (res) {
          this.form = res.data;
          this.getChartData(this.form?.area_form_id);
          console.log(this.form);
          this.$nextTick(() => {
            this.updateSelectedRoomData();
          });
        }
      });
    },
    async getChartData(id) {
      let res = await this.$apiFire(`Request/getSpiderChartPrepareData`, id);
      this.masterData = res.master_data;
      this.percent = this.calculateAVG(res.master_data);
      this.$nextTick(() => {
        this.updateSelectedRoomData();
      });
    },
    calculateAVG(data) {
      let arr = data?.chart_data.series[0]?.data;
      let max = data?.chart_data.yAxis.max;
      let total = 0;
      for (let i = 0; i < arr.length; i++) {
        total += arr[i];
      }
      return ((total / arr.length / max) * 100).toFixed(2);
    },
    validate(section) {
      let isCorrect = true;
      switch (section) {
        case "one_one":
          if (
            !this.form?.spider_chart_1?.company_name_th ||
            !this.form?.spider_chart_1?.company_name_en ||
            !this.form?.spider_chart_1?.company_address ||
            !this.form?.spider_chart_1?.company_postal_code ||
            !this.form?.spider_chart_1?.company_phone ||
            !this.form?.spider_chart_1?.company_email ||
            !this.form?.spider_chart_1?.company_website
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "one_two":
          if (!(this.form?.spider_chart_1?.attachments.length > 0)) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_three":
          if (this.percent == null) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_four":
          if (
            !this.form?.spider_chart_1?.space_needed ||
            !this.form?.spider_chart_1?.space_floor ||
            !this.form?.spider_chart_1?.space_room ||
            !this.form?.spider_chart_1?.space_area_size
          ) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_five":
          if (!this.form?.spider_chart_1?.space_type) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_six":
          if (!this.form?.spider_chart_1?.number_of_person) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_seven":
          if (!this.form?.spider_chart_1?.area_type_id) {
            isCorrect = false;
          }
          return isCorrect;

        //part two
        case "two_one":
          if (this.form?.spider_chart_2?.spider_chart_2_1?.length === 0) {
            isCorrect = false;
          } else {
            isCorrect = !this.form.spider_chart_2?.spider_chart_2_1.some(
              (item) =>
                !item.product_name ||
                item.attachment?.length === 0 ||
                !item.attachment
            );
          }
          return isCorrect;
        case "two_two":
          if (!this.form.spider_chart_2?.activity) {
            isCorrect = false;
          }
          return isCorrect;

        case "two_three":
          if (this.form.spider_chart_2?.spider_chart_2_3?.length === 0) {
            isCorrect = false;
          } else {
            isCorrect = !this.form.spider_chart_2?.spider_chart_2_3.some(
              (item) => !item.service_type || !item.service_price
            );
          }
          return isCorrect;
        case "two_four":
          if (!this.form?.spider_chart_2?.financial_stability) {
            isCorrect = false;
          }
          return isCorrect;
        case "two_five":
          if (!this.form?.spider_chart_2?.past_cooperation) {
            isCorrect = false;
          }
          return isCorrect;
        default:
          return isCorrect;
      }
    },
    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

      //change document title
      document.title = "SpiderChart_" + this.userInfo.user_type + "_" + today;
      let toHide = document.getElementsByClassName("to-hide");
      let pdfPage = document.getElementById("pdf");
      let mainContent = document.getElementById("main");
      let titled = document.getElementsByClassName("titled");
      let toShow = document.getElementsByClassName("to-show");
      let noBoxShadow = document.getElementsByClassName("no-box-shadow");
      let s3p1 = document.getElementsByClassName("s3-p1");
      let s3p1h = document.getElementsByClassName("s3-p1-h");
      let indent_info = document.getElementsByClassName("indent-info");

      //remove all class name indent-info
      for (let i = 0; i < indent_info.length; i++) {
        indent_info[i].style.paddingLeft = "10px";
      }

      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      for (let i = 0; i < titled.length; i++) {
        titled[i].style.boxShadow = "none";

        //set box shadow to every child of titled
        let titledChild = titled[i].children;
        for (let j = 0; j < titledChild.length; j++) {
          titledChild[j].style.boxShadow = "none";
        }
      }

      //set no-box-shadow box-shadow to none
      for (let i = 0; i < noBoxShadow.length; i++) {
        noBoxShadow[i].style.boxShadow = "none";

        //set border
        noBoxShadow[i].style.border = "1px solid #F5F5F5";
      }

      //set s3p1 style scale 0.8
      for (let i = 0; i < s3p1.length; i++) {
        s3p1[i].style.transform = "scale(0.75)";
        s3p1[i].style.transformOrigin = "top left";
        s3p1[i].style.alignItems = "flex-start";

        //remove class overflow-x-auto
        s3p1[i].classList.remove("overflow-x-auto");
      }
      //set s3p1h style height
      for (let i = 0; i < s3p1h.length; i++) {
        s3p1h[i].style.height = "auto";
      }

      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },
    handleImageError(event) {
      event.target.src = ""; // เปลี่ยนเป็น URL ของภาพสำรองถ้ามี
    },
    getPrefixImageByRegion(region) {
      switch (region) {
        case "ภาคตะวันออกเฉียงเหนือ":
          return "NE1";
        case "ภาคตะวันออกเฉียงเหนือตอนล่าง":
          return "NE2";
        default:
          return region;
      }
    },
    updateSelectedRoomData() {
      if (
        this.form?.spider_chart_1?.space_room &&
        this.masterData?.areaMasterRoom
      ) {
        this.selectedRoomData = this.masterData.areaMasterRoom.find(
          (room) => room.name === this.form.spider_chart_1.space_room
        );
      }
    },
  },
};
</script>

<style scoped>
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
